// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".configure-url-form{\n  display:flex;\n  align-items:baseline;\n  gap:8px;\n}", "",{"version":3,"sources":["webpack://./src/pages/AppSetting/Components/CampaignAnalytics/ConfigureUrls/ConfigureUrls.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,oBAAoB;EACpB,OAAO;AACT","sourcesContent":[".configure-url-form{\n  display:flex;\n  align-items:baseline;\n  gap:8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
